import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class CreateCustomerModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      name: "",
      email: "",
      phone: "",
      safeHarborMemberId: "",
      validationError: null,
    }
    this.validator = validatorFactory({
      validators: {
        requiredOrOther: {
          message: "One of either :attribute or :other is required.",
          rule: (val, params, validator) => {
            return (
              !validator.helpers.isBlank(val) ||
              !validator.helpers.isBlank(params[1])
            )
          },
          messageReplace: (message, params) =>
            message.replace(":other", params[0]),
          required: true,
        },
      },
    })
    this.save = this.save.bind(this)
  }

  save() {
    if (this.validator.allValid()) {
      this.setState({ saving: true })
      this.postSubmit()
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  postSubmit() {
    const formData = { name: this.state.name }
    if (this.state.email) {
      formData.email = this.state.email
    }
    if (this.state.phone) {
      formData.phone = this.state.phone
    }
    if (this.state.safeHarborMemberId) {
      formData.brewer_id = this.state.safeHarborMemberId
    }
    $.post(
      this.props.postUrl,
      formData,
      (data) => {
        this.props.selectContact(data)
      },
      "json"
    ).fail((data) => {
      const error = data.responseJSON
        ? data.responseJSON.error
        : "Error: " + data.statusText
      this.setState({
        saving: false,
        validationError: error,
        invalidEmailUrl: data.responseJSON && data.responseJSON.link,
      })
    })
  }

  errors() {
    if (this.state.validationError) {
      if (this.state.invalidEmailUrl) {
        return (
          <div>
            <p className="mb-3 font-bold text-red-600">
              {this.state.validationError}{" "}
              <a className="text-link" href={this.state.invalidEmailUrl}>
                View existing contacts.
              </a>
            </p>
          </div>
        )
      } else {
        return (
          <div>
            <p className="mb-3 font-bold text-red-600">
              {this.state.validationError}
            </p>
          </div>
        )
      }
    }
  }

  emailValidation() {
    if (this.props.phoneOptional) {
      return "email|required"
    } else {
      return `email|requiredOrOther:phone,${this.state.phone}`
    }
  }

  safeHarborID() {
    if (this.props.isSafeHarborLocation) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <FormGroup
              label="Safe Harbor Member ID"
              name="safeHarborMemberId"
              onChange={this.handleInputChange}
              value={this.state.safeHarborMemberId}
            />
          </div>
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <Modal isOpen={this.props.showModal} onClose={this.props.closeModal}>
        <Modal.Header title="Create new customer" />
        <Modal.Body>
          <div className="row">
            <div className="col-sm-12">
              <FormGroup
                label="Full Name"
                name="name"
                onChange={this.handleInputChange}
                required={true}
                validation={this.validator.message(
                  "name",
                  this.state.name,
                  "required"
                )}
                value={this.state.name}
              />
            </div>
          </div>
          <div className="row flex">
            <div className="col-sm-5 flex-grow">
              <FormGroup
                label="Email"
                name="email"
                onChange={this.handleInputChange}
                required={true}
                validation={this.validator.message(
                  "email",
                  this.state.email,
                  this.emailValidation()
                )}
                value={this.state.email}
              />
            </div>
            {!this.props.phoneOptional && (
              <div className="col-sm-1 self-center">OR</div>
            )}
            <div className="col-sm-5 flex-grow">
              <FormGroup
                label="Phone number"
                name="phone"
                onChange={this.handleInputChange}
                required={!this.props.phoneOptional}
                validation={this.validator.message(
                  "phone",
                  this.state.phone,
                  "phone"
                )}
                value={this.state.phone}
              />
            </div>
          </div>
          {this.safeHarborID()}
          {this.errors()}
        </Modal.Body>
        <Modal.Footer
          cancelBtnText="Cancel"
          confirmBtnText={this.state.saving ? "Creating..." : "Create"}
          confirmBtnLoading={this.state.saving}
          onClose={this.props.closeModal}
          onSubmit={this.save}
        />
      </Modal>
    )
  }
}

CreateCustomerModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  postUrl: PropTypes.string.isRequired,
  selectContact: PropTypes.func.isRequired,
  phoneOptional: PropTypes.bool,
  isSafeHarborLocation: PropTypes.bool,
}

export default CreateCustomerModal
